import request from "./request";

export const getLpPairAddress = (address) => {
    return new Promise(async (resolve, reject) => {
        await request
            .get(`/api/user/liquidity?address=${address}`)
            .then((res) => {
                resolve(res.data);
            })
            .catch((e) => {
                resolve(false);
            });
    });
};

export const getPathAddress = (address0, address1) => {
    return new Promise(async (resolve, reject) => {
        await request
            .get(`/api/user/liquidity/${address0}/${address1}`)
            .then((res) => {
                resolve(res.data);
            })
            .catch((e) => {
                resolve(false);
            });
    });
};

export const getSumsubToken = (address) => {
    return new Promise(async (resolve, reject) => {
        await request
            .get(`/api/user/sumsub/token/${address}`)
            .then((res) => {
                resolve(res.data);
            })
            .catch((e) => {
                resolve(e.response.data);
            });
    });
};